import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Attack",
    opening: localizedGenderNode(
      [
      "Today I do not fight the attack.",
      "I only notice: it is happening."
    ],
      [
      "Today I do not fight the attack.",
      "I only notice: it is happening."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does the attack feel in my body?",
      "What is the first sign it starts?",
      "What am I afraid will happen in that moment?"
    ],
      [
      "How does the attack feel in my body?",
      "What is the first sign it starts?",
      "What am I afraid will happen in that moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "This is a wave, not a danger."
    ],
      [
      "This is a wave, not a danger."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I am inside a wave\".",
      "one breath + \"I am inside a wave\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the moment the attack starts.",
      "I only notice."
    ],
      [
      "Today I notice the moment the attack starts.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit with myself for a moment.",
      "One breath."
    ],
      [
      "I sit with myself for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happened right before?",
      "Where was I when it began?",
      "What does my body do first?"
    ],
      [
      "What happened right before?",
      "Where was I when it began?",
      "What does my body do first?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment I have a little space."
    ],
      [
      "In the first moment I have a little space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when the attack starts.",
      "one breath when the attack starts."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Body Signals",
    opening: localizedGenderNode(
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ],
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where is the heartbeat strongest?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ],
      [
      "Where is the heartbeat strongest?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to protect me."
    ],
      [
      "My body is trying to protect me."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The Danger Story",
    opening: localizedGenderNode(
      [
      "Today I notice the story that tells danger.",
      "I do not fight it."
    ],
      [
      "Today I notice the story that tells danger.",
      "I do not fight it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What scenario jumps in first?",
      "What feels most frightening in it?",
      "What softer possibility could also be true?"
    ],
      [
      "What scenario jumps in first?",
      "What feels most frightening in it?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not a fact."
    ],
      [
      "A story is not a fact."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is a story rising\".",
      "an inner sentence - \"This is a story rising\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The Fear Beneath",
    opening: localizedGenderNode(
      [
      "Today I touch the fear beneath the attack.",
      "I stay with it for a moment."
    ],
      [
      "Today I touch the fear beneath the attack.",
      "I stay with it for a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid will happen?",
      "What hurts most in that thought?",
      "What do I need to hear now?"
    ],
      [
      "What am I afraid will happen?",
      "What hurts most in that thought?",
      "What do I need to hear now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear wants protection, not a fight."
    ],
      [
      "Fear wants protection, not a fight."
    ]
    ),
    action: localizedGenderNode(
      "name the fear quietly.",
      "name the fear quietly."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Body's Rhythm",
    opening: localizedGenderNode(
      [
      "Today I give my body a slower rhythm.",
      "Just a moment."
    ],
      [
      "Today I give my body a slower rhythm.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly and count one breath.",
      "One breath."
    ],
      [
      "I breathe slowly and count one breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What calms my body even a little?",
      "What is my body asking from me?",
      "How do I know it calms a bit?"
    ],
      [
      "What calms my body even a little?",
      "What is my body asking from me?",
      "How do I know it calms a bit?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A slow rhythm is an anchor."
    ],
      [
      "A slow rhythm is an anchor."
    ]
    ),
    action: localizedGenderNode(
      "one slow breath.",
      "one slow breath."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "The Need for Safety",
    opening: localizedGenderNode(
      [
      "Today I touch the need for safety beneath the attack.",
      "I stay with myself."
    ],
      [
      "Today I touch the need for safety beneath the attack.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel safe?",
      "What can help my body settle?",
      "What would I like to give myself now?"
    ],
      [
      "What do I need to feel safe?",
      "What can help my body settle?",
      "What would I like to give myself now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A little safety changes the tone."
    ],
      [
      "A little safety changes the tone."
    ]
    ),
    action: localizedGenderNode(
      "write one safety word.",
      "write one safety word."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Set It Down for a Moment",
    opening: localizedGenderNode(
      [
      "Today I see how it feels to set the attack down for a moment.",
      "Just a moment."
    ],
      [
      "Today I see how it feels to set the attack down for a moment.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I let my body soften a little.",
      "One breath."
    ],
      [
      "I let my body soften a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens in me when I set it down?",
      "What scares me about setting it down?",
      "What calms me even a little?"
    ],
      [
      "What happens in me when I set it down?",
      "What scares me about setting it down?",
      "What calms me even a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Setting it down for a moment is also a choice."
    ],
      [
      "Setting it down for a moment is also a choice."
    ]
    ),
    action: localizedGenderNode(
      "one moment without fighting my body.",
      "one moment without fighting my body."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "A Soft Inner Language",
    opening: localizedGenderNode(
      [
      "Today I choose to speak to myself gently.",
      "Not by force."
    ],
      [
      "Today I choose to speak to myself gently.",
      "Not by force."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe and notice my inner voice.",
      "One breath."
    ],
      [
      "I breathe and notice my inner voice.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I speak to myself during an attack?",
      "How would I like to hear it?",
      "What is my gentle sentence?"
    ],
      [
      "How do I speak to myself during an attack?",
      "How would I like to hear it?",
      "What is my gentle sentence?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A gentle voice lowers pressure."
    ],
      [
      "A gentle voice lowers pressure."
    ]
    ),
    action: localizedGenderNode(
      "say the gentle sentence once.",
      "say the gentle sentence once."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Moment Before Running",
    opening: localizedGenderNode(
      [
      "Today I pause a moment before I run.",
      "Just a moment."
    ],
      [
      "Today I pause a moment before I run.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice the urge to run.",
      "One breath."
    ],
      [
      "I notice the urge to run.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I trying to run from?",
      "What happens if I stay a moment?",
      "What can support me for one moment?"
    ],
      [
      "What am I trying to run from?",
      "What happens if I stay a moment?",
      "What can support me for one moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment changes direction."
    ],
      [
      "A small moment changes direction."
    ]
    ),
    action: localizedGenderNode(
      "one breath before running.",
      "one breath before running."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Return to the Present",
    opening: localizedGenderNode(
      [
      "Today I return to this moment.",
      "I am with myself."
    ],
      [
      "Today I return to this moment.",
      "I am with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel the weight of my body.",
      "One breath."
    ],
      [
      "I feel the weight of my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I hear right now?",
      "What do I see around me?",
      "What do I feel in this moment?"
    ],
      [
      "What do I hear right now?",
      "What do I see around me?",
      "What do I feel in this moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The present gives me ground."
    ],
      [
      "The present gives me ground."
    ]
    ),
    action: localizedGenderNode(
      "feel my feet for a moment.",
      "feel my feet for a moment."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "A Moment Before Checking",
    opening: localizedGenderNode(
      [
      "Today I pause before I check if it passed.",
      "Just a moment."
    ],
      [
      "Today I pause before I check if it passed.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice the urge to check.",
      "One breath."
    ],
      [
      "I notice the urge to check.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I trying to make sure of?",
      "What happens if I do not know right away?",
      "What can help me wait a moment?"
    ],
      [
      "What am I trying to make sure of?",
      "What happens if I do not know right away?",
      "What can help me wait a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Waiting a moment is quiet strength."
    ],
      [
      "Waiting a moment is quiet strength."
    ]
    ),
    action: localizedGenderNode(
      "pause before checking.",
      "pause before checking."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Step",
    opening: localizedGenderNode(
      [
      "Today I choose a small step that calms me.",
      "Not a revolution."
    ],
      [
      "Today I choose a small step that calms me.",
      "Not a revolution."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly and look around.",
      "One breath."
    ],
      [
      "I breathe slowly and look around.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step can help me calm?",
      "When can I do it?",
      "What will help me remember?"
    ],
      [
      "What small step can help me calm?",
      "When can I do it?",
      "What will help me remember?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small enough is enough."
    ],
      [
      "Small enough is enough."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step.",
      "choose one small step."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ],
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause a moment before response.",
      "One breath."
    ],
      [
      "I pause a moment before response.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about these attacks?",
      "What is the first sign they rise?",
      "What is my short sentence?"
    ],
      [
      "What did I learn about these attacks?",
      "What is the first sign they rise?",
      "What is my short sentence?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I choose a moment before response."
    ],
      [
      "I choose a moment before response."
    ]
    ),
    action: localizedGenderNode(
      "one breath + my sentence.",
      "one breath + my sentence."
    ),
  },
].map(buildNormalizedDay);

export const anxietyPanicAttacksBlueprintEn = buildNormalizedPilotBlueprint({
  id: "anxiety_panic_attacks_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "anxiety_panic_attacks",
  category: "anxiety",
  journeyName: {
    he: "התקפי חרדה חוזרים (דופק, קוצר נשימה)",
    en: "Recurrent anxiety attacks (palpitations, shortness of breath)",
    es: "Ataques de ansiedad recurrentes (palpitaciones, dificultad para respirar)",
  },
  days,
});

export default anxietyPanicAttacksBlueprintEn;
